import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorMasterRoleSearch = () => {
  const searchRole = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/master-role/search', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { searchRole }
}

export default InteractorMasterRoleSearch
